export const LogoMark = ({ className = "w-11 h-11" }) => (
  <img src="/images/elevion-mark-160.png" width="160" height="144" alt="Elevion Care Network LLC logo" className={`${className} object-contain`} />
);

export const Wordmark = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-wordmark">
    <LogoMark className="w-11 h-11 shrink-0" />
    <span className="leading-none">
      <span className={`block font-brand text-[19px] font-medium tracking-[0.28em] ${light ? "text-[#FBF8F1]" : "text-[#154F49]"}`}>ELEVION</span>
      <span className={`block font-brand text-[9px] tracking-[0.3em] mt-1.5 ${light ? "text-[#E2C372]" : "text-[#154F49]"}`}>CARE NETWORK LLC</span>
    </span>
  </span>
);

export const LogoTile = ({ className = "w-24 h-24" }) => (
  <span className={`${className} rounded-2xl bg-[#FBF8F1] p-1.5 shrink-0 flex items-center justify-center border border-[#CDA34F]`}>
    <img src="/images/elevion-logo-240.png" alt="Elevion Care Network LLC logo" loading="lazy" className="w-full h-full object-contain" />
  </span>
);
